export function saveDocumentCore(ctx: Word.RequestContext): { ok: true } {
  ctx.document.save();
  // Intentionally no await ctx.sync() — the wrapper's final sync flushes
  // this. Adding one here would be redundant and harmless, but omitting keeps
  // the pattern consistent with other queue-only executors.
  return { ok: true };
}
